export default "__VITE_ASSET__C1rJcMxq__"